import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { ForgotPasswords } from "../api/api";
import "../UserProfileEdit/ResetPassword.css";
import bgImage from "../../assets/images/brown-background.jpg";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const ResetPassword = ({ route }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const emailss = location.state?.emailss || "";
  console.log("emailss1", emailss);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      console.log("Submitted Email:", values);
      const response = await ForgotPasswords(values);
      if (response?.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.msg,
        }).then(() => {
          navigate("/Sidebar/SetResetPassword", {
            state: { values },
          });
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response?.msg || "Something went wrong",
        });
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
      console.error("API Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="resetpassword-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <h2 className="resetpassword-heading">Reset Password</h2>{" "}
      {/* <-- Add this */}
      <div className="headingpassword">
        <p>Don't worry, it happens. We will send the OTP to this email.</p>
      </div>
      <Formik
        initialValues={{ email: emailss }}
        validationSchema={validationSchema}
        // onSubmit={handleSubmit}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ errors, touched, handleSubmit }) => (
          <form onSubmit={handleSubmit} className="resetpassword-form">
            <div className="inputpassword-group">
              {/* <label>Email Address</label> */}
              <input
                type="email"
                name="email"
                disabled
                value={
                  emailss
                    ? `${emailss[0]}${"X".repeat(5)}${emailss.slice(-13)}`
                    : ""
                }
              />
              {touched.email && errors.email && (
                <span className="error">{errors.email}</span>
              )}
            </div>
            <button
              type="submit"
              className="submitpassword-btn"
              disabled={isLoading}
            >
              {isLoading ? "Sending OTP..." : "Continue"}
            </button>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default ResetPassword;
